import React, { FC } from 'react'
import { StyledTooltip, StyledTooltipMessage } from './tooltip.styles'

interface TooltipProps {
    message: string
    position?: 'centre' | 'right' | 'left'
    children: React.JSX.Element
    width?: string
}

export const Tooltip: FC<TooltipProps> = ({ message, position = 'right', children, width = '' }) => {
    return (
        <StyledTooltip tabIndex={0}>
            {children}
            <StyledTooltipMessage aria-hidden as="p" $position={position} $width={width}>
                {message}
            </StyledTooltipMessage>
        </StyledTooltip>
    )
}
